import React from "react";

import { Text } from "react-internationalization";
import { connect } from "react-redux";
const DefaultTermAndCondition = (props) => {
  return (
    <div>
      {props.agentLoggedIn === false && (
        <div class="card mt-3">
          <h3 class="card-header block-heading">
            <Text id="app.imp" /> : <Text id="app.impsub" />
          </h3>
          <div class="panel">
            <div class="card-body">
              <ul>
                <li>
                  <Text id="app.imp1" />.
                </li>
                <li>
                  <Text id="app.imp2" />.
                </li>
                <li>
                  <Text id="app.imp3" />.
                </li>
                <li>
                  <Text id="app.imp4" />.
                </li>
                <li>
                  <Text id="app.imp5" />.
                </li>
                <li>
                  <Text id="app.imp6" />.
                </li>
                <li>
                  <Text id="app.imp7" />:{" "}
                </li>
                <Text id="app.imp8" />
                <br />
                <Text id="app.imp9" />
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export const VerdaTermsAndCondition = () => {
  return (
    <div>
      <div class="card mt-3">
        <h3 class="card-header block-heading">
          <Text id="app.imp" /> : <Text id="app.impsub" />
        </h3>
        <div class="panel">
          <div class="card-body">
            <ul>
              <li>
                <Text id="verda.imp1" />.
              </li>
              <li>
                <Text id="verda.imp2" />.
              </li>
              <li>
                <Text id="verda.imp3" />.
              </li>
              <li>
                <Text id="verda.imp4" />.
              </li>
              <li>
                <Text id="verda.imp5" />.
              </li>
              <li>
                <Text id="verda.imp6" />.
              </li>
              <Text id="verda.imp6Sub1" />
              <br />
              <Text id="verda.imp6Sub2" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    agentLoggedIn: state.login.agentLoggedIn,
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultTermAndCondition);
